<template>
  <v-alert
    v-if="account"
    :type="declared ? 'success' : 'warning'"
    density="comfortable"
    class="mb-4"
  >
    <div class="font-weight-medium">
      {{ declared ? $t("ncrm.integrations.pbx.recordingBasis.declaredTitle") : $t("ncrm.integrations.pbx.recordingBasis.missingTitle") }}
    </div>

    <div v-if="declared" class="text-body-2 mt-1">
      {{ basis.note }}
    </div>
    <div v-else class="text-body-2 mt-1">
      {{ $t("ncrm.integrations.pbx.recordingBasis.missingHint") }}
    </div>

    <template v-if="!declared || editing">
      <v-textarea
        v-model="note"
        :label="$t('ncrm.integrations.pbx.recordingBasis.noteLabel')"
        :hint="$t('ncrm.integrations.pbx.recordingBasis.noteHint')"
        :error-messages="error ? [error] : []"
        persistent-hint
        rows="2"
        auto-grow
        counter="500"
        maxlength="500"
        class="mt-3"
      />
      <div class="d-flex ga-2 mt-2">
        <v-btn color="primary" :loading="saving" @click="save">
          {{ $t("ncrm.integrations.pbx.recordingBasis.confirm") }}
        </v-btn>
        <v-btn v-if="declared" variant="text" @click="editing = false">
          {{ $t("ncrm.integrations.pbx.recordingBasis.cancel") }}
        </v-btn>
      </div>
    </template>
    <div v-else class="mt-2">
      <v-btn variant="text" size="small" @click="startEdit">
        {{ $t("ncrm.integrations.pbx.recordingBasis.edit") }}
      </v-btn>
    </div>
  </v-alert>
</template>

<script>
import axios from "axios";

// DPIA acțiunea A5 (riscul R13) — declarația de temei pentru înregistrarea
// apelurilor.
//
// Platforma stochează și redă voce. Fără această declarație, ruta de redare
// întoarce `409 pbx_recording_basis_not_declared`, deci cardul nu este
// decorativ: este singurul loc din care blocajul se ridică.
//
// Nota este obligatorie când se declară. O bifă fără explicație ar fi exact
// booleanul-fără-dovadă pe care epicul îl elimină în alte locuri.
export default {
  name: "NcrmPbxRecordingBasisCard",
  props: {
    account: { type: Object, default: null },
  },
  emits: ["updated"],
  data() {
    return {
      note: "",
      editing: false,
      saving: false,
      error: "",
    };
  },
  computed: {
    basis() {
      return this.account?.recording_basis || { declared: false, note: null };
    },
    declared() {
      return Boolean(this.basis.declared);
    },
  },
  watch: {
    account: {
      immediate: true,
      handler() {
        this.note = this.basis.note || "";
        this.editing = false;
        this.error = "";
      },
    },
  },
  methods: {
    startEdit() {
      this.note = this.basis.note || "";
      this.editing = true;
      this.error = "";
    },
    async save() {
      const note = String(this.note || "").trim();
      if (!note) {
        this.error = this.$t("ncrm.integrations.pbx.recordingBasis.noteRequired");
        return;
      }
      this.saving = true;
      this.error = "";
      try {
        const { data } = await axios.post(
          `/ncrm/integrations/pbx/accounts/${this.account.id}/recording-basis`,
          { declared: true, note }
        );
        this.editing = false;
        this.$emit("updated", data?.account || null);
      } catch (err) {
        this.error =
          err?.response?.data?.error || this.$t("ncrm.integrations.pbx.recordingBasis.saveError");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
